import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BuyService} from '../../../../buy/buy.service';
import {firstValueFrom} from 'rxjs';

@Component({
    selector: 'app-workflow-endcustomer-one-trial-prepare',
    templateUrl: './workflow-endcustomer-one-trial-prepare.component.html',
    standalone: false
})
export class WorkflowEndcustomerOneTrialPrepareComponent implements OnInit {
    public initialized = false;
    public orderName: string;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private buyService: BuyService
    ) {}

    async ngOnInit() {
        const so = this.route.snapshot.paramMap.get('so');
        if (!so) {
            this.router.navigate(['/'], {replaceUrl: true});
            return;
        }

        try {
            // Load the sale order — this also populates m.buy.currentOrder as a side effect,
            // so cloud-thankyou's autorun fires immediately on mount instead of waiting 15s.
            await firstValueFrom(this.buyService.getSaleOrder(so));
            this.orderName = so;
            this.initialized = true;
        } catch {
            this.router.navigate(['/'], {replaceUrl: true});
        }
    }
}
